// extracted by mini-css-extract-plugin
export default {"-large":"V00viVRSsIzLY9aSYvMS","platformsGrid":"dtWqg3aC82RQ9KYC5Xms","mobileGridSpacer":"cPEE8zTgaA8Chv6ZI5gG"};